import React from 'react'
import * as  C from "../componentsM/index"

const StudiesInLanguage = () => {
    return (
        <>

            <C.Hero title={"GROUP 1: STUDIES IN LANGUAGE AND LITERATURE"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The courses in this Group are designed for students who have experience of using the language of the course in an academic context. The language background of such students, however, is likely to vary considerably—from mono-lingual students to students with more complex language profiles.</p>

                    <p>The study of texts, both literary and non-literary, provides a focus for developing an understanding of how language works to create meanings in a culture, as well as in particular texts. All texts may be understood according to their form, content, purpose and audience, and through the social, historical, cultural and workplace contexts that produce and value them. Responding to, and producing texts promotes an understanding of how language sustains or challenges ways of thinking and being.</p>

                    <p>Subjects currently offered:

                    </p>


                    <p>English A – Language and Literature (SL & HL)</p>

                    <p>This course aims to develop in students, skills of textual analysis and the understanding that texts, both literary and non-literary, can be seen as autonomous yet simultaneously related to culturally determined reading practices.</p>

                    <p>Urdu A – Literature (SL & HL)</p>

                    <p>Through the study of a wide range of literature, the language A: literature course encourages students to appreciate the artistry of literature and to develop an ability to reflect critically on their reading.</p>

                    <p>Extended Essay (EE)</p>

                    <p>The extended essay is an in-depth study of a focused topic chosen from the list of available Diploma Programme subjects for the session in question. This is normally one of the student’s six chosen subjects for those taking the IB diploma, or a subject that a course student has a background in. It is intended to promote academic research and writing skills, providing students with an opportunity to engage in personal research in a topic of their own choice, under the guidance of a supervisor (assigned by the school). This leads to a major piece of formally presented, structured writing, in which ideas and findings are communicated in a reasoned and coherent manner, appropriate to the subject chosen. This essay has to be 4,000 words maximum.</p>

                </div>
            </section>

        </>

    )
}

export default StudiesInLanguage